<template>
    <div class="flex-form__inline">
        <span class="flex-form__inline-text">
            with the ID
        </span>

        <content-editable
            :class="getInvalidClass('targetProperty')"
            :value="dataNew.targetProperty"
            @input="onInput"
        />
    </div>
</template>

<script>
import eventDataMixin from '@/mixins/event-data';

export default {
    name: 'condition-target-form',
    mixins: [eventDataMixin],

    computed: {
        schema() {
            return {
                targetProperty: {
                    type: String,
                    default: '',
                    required: true,
                },
            };
        },
    },

    methods: {
        onInput(value) {
            this.dataNew.targetProperty = value;
        },
    },
};
</script>
